<script>
import Button from "@/components/atoms/button";
import DropDown from "@/components/molecules/drop-down";
import DropDownItem from "@/components/molecules/drop-down/drop-down-item";

export default {
  name: "OrderSummaryMultipay",
  components: {
    Button,
    DropDown,
    DropDownItem
  },
  props: {
    cbx3: {
      type: Object,
      required: false,
      default: null
    },
    cbx4: {
      type: Object,
      required: false,
      default: null
    },
    mensualites: {
      type: Number,
      required: false,
      default: null
    },
    nbMensualites: {
      type: Number,
      required: false,
      default: 0
    },
    frais: {
      type: Number,
      required: false,
      default: null
    }
  },
  emits: ["changeCodeSimulateur", "openPopin"]
};
</script>

<template>
  <div class="u-text-right u-mt-xs">
    <div
      class="u-color-text-light u-font-14 u-font-15@sm"
      :class="cbx3 ? 'u-flex-align-baseline' : cbx4 ? 'u-flex-align-baseline' : 'u-flex-align-center'"
    >
      OU
      <DropDown
        v-if="cbx3 && cbx4"
        ref="dropdown"
        radius="sm"
        size="sm"
        icon-color="white"
        multipay-panier
        class="u-mx-xxs"
      >
        <template #button-content>
          <span>
            {{ nbMensualites }}
          </span>
        </template>
        <DropDownItem>
          <Button
            variant="text"
            class="u-my-xs"
            @click="$emit('changeCodeSimulateur', cbx3.attributes.code_paiement_simulateur)"
          >
            3
          </Button>
        </DropDownItem>
        <DropDownItem>
          <Button
            variant="text"
            class="u-my-xs"
            @click="$emit('changeCodeSimulateur', cbx4.attributes.code_paiement_simulateur)"
          >
            4
          </Button>
        </DropDownItem>
      </DropDown>
      <span
        v-else
        class="u-font-16 u-font-17@sm u-color-text u-font-700 u-ml-xs u-mr-xxs"
      >
        {{ nbMensualites }}&nbsp;x
      </span>
      <span class="u-font-16 u-font-17@sm u-font-700 u-color-secondary">
        <template v-if="cbx3 && cbx4">x</template>
        {{ formatPrix(mensualites) }} <span class="u-font-12">€</span>
      </span>
    </div>
    <p
      v-if="frais"
      class="u-mt-xxs u-font-14"
    >
      + {{ formatPrix(frais) }} <span class="u-font-12">€</span> de frais de dossier
    </p>
    <Button
      link
      variant="text-light"
      class="u-mt-xxs"
      @click="$emit('openPopin')"
    >
      Réglez en {{ nbMensualites }} fois {{ frais ? "avec" : "sans" }} frais
    </Button>
  </div>
</template>

<style lang="scss" scoped>
</style>
